import { Col } from "@amzn/stencil-react-components/layout";
import React from "react";

import { FAQItem } from "@/helpers/faq-helper";

import { FAQItemContent } from "./FAQItemContent";

interface FAQListProps {
  items: FAQItem[];
}

/**
 * Renders a vertical list of FAQ items with consistent spacing.
 *
 * @component
 * @param {FAQItem[]} items - Array of FAQ items to display
 */

export const FAQList = ({ items }: FAQListProps) => (
  <Col gridGap="S300" dataTestId={"faq-list-data-test"}>
    {items.map((item) => (
      <FAQItemContent key={item.dataTestId} item={item} />
    ))}
  </Col>
);
